import {gsap} from 'gsap'
import {Power1} from 'gsap/gsap-core'
import * as ScrollMagic from 'scrollmagic'
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap'

export class ImageFadeInParallax {
    constructor(el) {
        if (el.nodeName.toLowerCase() !== 'img') {
            console.warn('ImageFadeInParallax can only be applied to images wrapped into lower size node')
        } else {
            this._el = el
            this._fadeInDuration = 0.5
            this._options = {
                threshold: 0.2 // at least x% visible
            }
            this._prepareElement()
            this._setupObserver()
        }
    }

    _prepareElement() {
        let wrapperHeight = this._el.parentNode.getBoundingClientRect().height
        let imageHeight = this._el.getBoundingClientRect().height
        // console.log(wrapperHeight, imageHeight)
        this._shift = imageHeight - wrapperHeight;
        gsap.to(this._el,
            {opacity: 0}
        )
    }

    _setupObserver() {
        this._observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach(
                    (entry) => {
                        if (entry.isIntersecting /*&& document.body.classList.contains('can-animate')*/) {
                            this._observer.unobserve(this._el.parentNode)
                            this._performAnimation()
                        }
                    }
                )
            },
            this._options
        )
        this._observer.observe(this._el.parentNode)
    }

    _performAnimation () {
        gsap.to(this._el,
            {duration: this._fadeInDuration, opacity: 1}
        )
        this._controller = new ScrollMagic.Controller()
        this._tl = new gsap.timeline()
        this._tl.to(this._el, 1, { y: this._shift })
        ScrollMagicPluginGsap(ScrollMagic, gsap);
        this._scene = new ScrollMagic.Scene({
            triggerElement: this._el.parentNode,
            triggerHook: 0.4,
            duration: "100%"
        })
            .setTween(this._tl)
            .addTo(this._controller);
    }
}
